module.exports = __webpack_public_path__ + "static/media/logo.acbe0db8.svg";